import { doGet } from "./common";

function getBinAlgData(params, callback) {
  //console.log("### PriceGetData##");
  doGet("/data/BinAlgData", params, callback).then();
}
function getHistoricGraphData(params, callback) {
  //console.log("### PriceGetData##");
  doGet("/data/getHistoricGraphData", params, callback).then();
}
export { getBinAlgData, getHistoricGraphData };
